import { render, staticRenderFns } from "./HubSidebar.vue?vue&type=template&id=6227b400&"
import script from "./HubSidebar.vue?vue&type=script&lang=js&"
export * from "./HubSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports